import client from '../api/client';

const MAX_DIM = 2048;
const JPEG_QUALITY = 0.85;
const COMPRESS_THRESHOLD = 800 * 1024; // 800 КБ — как на сервере

// Жмём только JPEG-фото, которые крупнее 2048px по стороне или тяжелее 800 КБ.
// PNG (прозрачность логотипов) и GIF (анимация) не трогаем — их нормализует сервер.
async function maybeCompress(file) {
  const isJpeg = file.type === 'image/jpeg' || file.type === 'image/jpg';
  if (!isJpeg) return file;
  if (file.size <= COMPRESS_THRESHOLD) return file;

  try {
    const bitmap = await createImageBitmap(file);
    const longSide = Math.max(bitmap.width, bitmap.height);
    if (longSide <= MAX_DIM) {
      // Размер в пикселях нормальный — сервер дожмёт по весу, не трогаем
      bitmap.close?.();
      return file;
    }

    const scale = MAX_DIM / longSide;
    const width = Math.round(bitmap.width * scale);
    const height = Math.round(bitmap.height * scale);
    const canvas = document.createElement('canvas');
    canvas.width = width;
    canvas.height = height;
    const ctx = canvas.getContext('2d');
    ctx.drawImage(bitmap, 0, 0, width, height);
    bitmap.close?.();

    const blob = await new Promise((resolve) => canvas.toBlob(resolve, 'image/jpeg', JPEG_QUALITY));
    if (!blob || blob.size >= file.size) return file; // не лучше исходного — грузим оригинал
    const name = file.name.replace(/\.\w+$/, '.jpg');
    return new File([blob], name, { type: 'image/jpeg' });
  } catch {
    return file; // любая ошибка (битый файл, нет canvas) — грузим оригинал
  }
}

export async function uploadFile(file) {
  const toSend = await maybeCompress(file);
  const formData = new FormData();
  formData.append('file', toSend);
  const res = await client.post('/admin/upload', formData, {
    headers: { 'Content-Type': undefined },
  });
  return res.data.url;
}
